module.exports = __webpack_public_path__ + "img/4-4.a76f5652.jpg";